<template>
  <div class="atlas-page">
    <div class="row atlas-page-header">
      <div class="row">
        <div
          class="tab-item" 
          :class="{'tab-item-active': item === selectedOptionTab}" 
          v-for="(item, index) in tabs" 
          :key="index"
          @click="onTabChange(item)"
          >
          {{item}}
        </div>
      </div>
    </div>
    <check-relation v-if="selectedOptionTab==='查关系'"></check-relation>
    <check-company v-if="selectedOptionTab==='查公司'"></check-company>

  </div>
</template>

<script>
// eslint-disable-next-line
import CheckRelation from '@/components/atlas/CheckRelation';
import CheckCompany from '@/components/atlas/CheckCompany';


export default {
  data() {
    return {
      tabs: ['查公司', '查关系'],
      selectedOptionTab: '查公司'
    };
  },
  methods: {
    onTabChange(item) {
      this.selectedOptionTab = item;
      if (this.selectedOptionTab === '查关系') {
        this.$router.push({
          path: '/graph',
          query: {
            type: 'relation'
          }
        });
      } else {
        this.$router.push({
          path: '/graph'
        });
      }
    }
  },
  watch: {
    $route() {
      if (this.$route.query.type) {
        this.selectedOptionTab = '查关系';
      } else {
        this.selectedOptionTab = '查公司';
      }
    }
  },
  components: {
    CheckRelation,
    CheckCompany
  },
  mounted() {
    if (this.$route.query.type) {
      this.selectedOptionTab = '查关系';
    } else {
      this.selectedOptionTab = '查公司';
    }
  }
};
</script>

<style lang="scss" scoped>
.atlas-page {
  width: 1200px;
  margin: 0 auto;
  padding: 16px 0 0;
  min-height: calc(100vh - 59px);
  .atlas-page-header {
    justify-content: space-between;
    padding: 0 24px;
    height: 44px;
    line-height: 44px;
    width: 100%;
    color: #747990;
    background-color: #ffffff;
    font-size: 14px;
    .tab-item {
      margin-right: 32px;
      cursor: pointer;
      &:hover {
        color: #45a8cc;
      }
    }
    .tab-item-active {
      color: #45a8cc;
    }
  }
}
</style>

